import { showActionModal } from './blog-action-info-modal.js';
document.addEventListener('DOMContentLoaded', function () {
    const copyArticleLinkButton = document.querySelector(".copy-article-link-button");

    if (!copyArticleLinkButton) return;

    copyArticleLinkButton.addEventListener("click", function () {
        const record_url = document.URL;

        navigator.clipboard.writeText(record_url)
            .then(() => {
                showActionModal('Ссылка скопирована');
            })
            .catch(() => {
                showActionModal('Не удалось скопировать ссылку');
            });
    });
});
